function SuspenseFallback() {
  return (
    <div className="w-screen h-screen flex justify-center items-center">
      Loading...
    </div>
  );
}

export default SuspenseFallback;
